export default __webpack_public_path__ + "static/media/008-radiation.27d5da5e.svg";